import React, { useState, useEffect, useRef } from "react";
import { registerLicense } from "@syncfusion/ej2-base";
import { API } from "../../config/api";
import { ApiHelper } from "../../helpers/ApiHelper";
import Spinner from "../../components/Spinner";
import Alert from "../../assets/images/alert-circle.svg";
// import closex from "../../assets/images/X.svg";
import closex from "../../assets/images/X.svg";
import Modal from "react-modal";
import "./DocumentUpload.css";
import "../../index.css";
import frame from "../../assets/images/Frame-green.svg";

import {
  PdfViewerComponent,
  Toolbar,
  Magnification,
  Navigation,
  LinkAnnotation,
  BookmarkView,
  ThumbnailView,
  Print,
  TextSelection,
  TextSearch,
  Annotation,
  FormFields,
  FormDesigner,
  Inject,
} from "@syncfusion/ej2-react-pdfviewer";
import {
  ToolbarComponent,
  ItemsDirective,
  ItemDirective,
} from "@syncfusion/ej2-react-navigations";
import { useParams } from "react-router";

const DocumentUpload = ({
  intervieweeid,
  setModalData,
  setIsOpen,
  form,
  item,
  data,
  setPdfViewer,
  currentPath,
}) => {
  const params = useParams();
  const toolbarRef = useRef(null);
  const [enableToolbar, setEnableToolbar] = useState(false);
  const [loader, setLoader] = useState(false);
  const pdfViewerRef = useRef(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [errorValue, setErrorValue] = useState("");
  const [filledBy, setFilledBy] = useState("");
  const [documentLoadedCalled, setDocumentLoadedCalled] = useState(false);
  const [totalPageCount, setTotalPageCount] = useState("of 0");
  const [current_page_number, setCurrent_page_number] = useState();
  const [title, setTitle] = useState("");
  const [formId, setFormId] = useState();
  const storedItem = JSON.parse(localStorage.getItem("profile"));

  registerLicense(
    "Ngo9BigBOggjHTQxAR8/V1NAaF5cWWJCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWXxecXRQRWNcWEZ+WUo="
  );
  const [buttonText, setButtonText] = useState("");
  let toolbar;
  const ChatbotId = localStorage.getItem("candidateChatbotId");
  const selectedCandidate = localStorage.getItem("selectedCandidate");
  let user = JSON.parse(localStorage.getItem("UserData"));

  useEffect(() => {
    if (currentPath == "review") {
      setTitle(data.title);
      setFormId(data?.id);
      setButtonText("confirm");
      setEnableToolbar(true);
      setFilledBy("employer");
    } else if (currentPath == "preview") {
      setButtonText("cancel");
      setEnableToolbar(false);
    } else {
      setButtonText("submit");
      setFilledBy("candidate");
    }
  });

  // useEffect(() => {
  //   if (pdfViewerRef.current && item.file_buffer_encrypted_value) {
  //     pdfViewerRef.current.load(item.file_buffer_encrypted_value);
  //   }
  // }, [pdfViewerRef, item]);

  const documentBase64 = () => {
    console.log("documentBase64", item.file_buffer_encrypted_value);
    return item.file_buffer_encrypted_value;
  };

  function created() {
    setTimeout(() => {
      console.log("item.file_buffer_encrypted_value", item);
      if (pdfViewerRef.current && item.file_buffer_encrypted_value) {
        pdfViewerRef.current.load(documentBase64());
      }
    }, 200);
  }

  async function clickHandler(args) {
    var viewer = document.getElementById("container").ej2_instances[0];
    if (args.item.id == "cancel") {
      setPdfViewer(false);
    } else if (args.item.id == "form_designer") {
      var viewer = document.getElementById("container").ej2_instances[0];
      viewer.toolbarModule.showAnnotationToolbar(true);
      // viewer.isFormDesignerToolbarVisible = true;
      // viewer.enableAnnotationToolbar = true;
    } else if (args.item.id == "previous_page") {
      pdfViewerRef.current.navigation.goToPreviousPage();
    } else if (args.item.id == "next_page") {
      pdfViewerRef.current.navigation.goToNextPage();
    } else if (args.item.id == "zoom_in") {
      pdfViewerRef.current.magnification.zoomIn();
    } else if (args.item.id == "zoom_out") {
      pdfViewerRef.current.magnification.zoomOut();
    } else {
      if (buttonText == "confirm" || buttonText == "submit") {
        var viewer = document.getElementById("container").ej2_instances[0];
        var forms = viewer.formFieldCollections;
        let validationError = null;
        let radioGroupNames = {};
        let allRequiredFieldsFilled = true;
        for (let i = 0; i < forms.length; i++) {
          const field = forms[i];
          if (field.isRequired) {
            if (field.type === "Checkbox") {
              if (!field.isChecked) {
                validationError = `"${field?.name}" must be checked`;
                allRequiredFieldsFilled = false;
                break; // Exit the loop on the first validation error
              }
            } else if (field.type === "SignatureField") {
              if (!field.value) {
                validationError = `Please provide a signature for "${field?.name}"`;
                allRequiredFieldsFilled = false;
                break; // Exit the loop on the first validation error
              }
            } else if (buttonText == "submit" && field.type === "RadioButton") {
              // Check if a radio button with the same name is already selected
              if (
                radioGroupNames[field.name] &&
                radioGroupNames[field.name].isSelected
              ) {
                // No need to show validation message as at least one radio button is selected
                continue;
              }

              // Track the radio button group and check if this radio button is selected
              radioGroupNames[field.name] = radioGroupNames[field.name] || {
                isSelected: false,
              };
              if (field.isSelected) {
                radioGroupNames[field.name].isSelected = true;
              }
            } else if (field.type != "RadioButton") {
              const value = field.value;
              // Check if the value is empty or contains only spaces
              if (!value || value.trim() === "") {
                validationError = `"${field?.name}" must not be left blank`;
                allRequiredFieldsFilled = false;
                break; // Exit the loop on the first validation error
              }
            }
          }
        }
        for (const groupName in radioGroupNames) {
          if (!radioGroupNames[groupName].isSelected) {
            validationError = `Please select a value for "${groupName}"`;
            allRequiredFieldsFilled = false;
            break;
          }
        }
        if (validationError) {
          setErrorValue(validationError);
          setModalIsOpen(true);
        } else {
          for (let i = 0; i < forms.length; i++) {
            const field = forms[i];
            if (
              field.isRequired == false &&
              field.value == "" &&
              field.type != "Checkbox"
            ) {
              viewer.formDesignerModule.updateFormField(forms[i], {
                value: "N/A",
              });
            }
          }
          if (buttonText == "confirm") {
            for (let i = 0; i < forms.length; i++) {
              const field = forms[i];
              if (field.type === "RadioButton") {
                // For radio buttons, you may need to handle them differently
                // Update the field based on your requirements
                // For example, you might want to set isReadOnly or isChecked
                viewer.formDesignerModule.updateFormField(forms[i], {
                  isReadOnly: true, // or any other properties you need to set
                  isChecked: field.isSelected, // Maintain the current selected state
                });
              } else {
                // For other field types, update them as needed
                viewer.formDesignerModule.updateFormField(forms[i], {
                  isReadOnly: true,
                });
              }
            }
          }
          var data;
          setLoader(true);

          try {
            const value = await saveAsBlobAsync(viewer);

            var reader = new FileReader();

            // Define a function to execute when the reader finishes reading the Blob
            reader.onloadend = async function () {
              if (reader.readyState === FileReader.DONE) {
                // The result property contains the Base64-encoded data
                var base64Data = reader.result;

                if (buttonText === "confirm") {
                  const dataValue = new FormData();
                  dataValue.append("base64String", base64Data);
                  dataValue.append("formfieldid", item.id);
                  dataValue.append("chatbotid", ChatbotId);
                  dataValue.append("intervieweeid", intervieweeid);
                  dataValue.append("formid", formId);
                  dataValue.append("pdf_name", title);
                  dataValue.append("userId", user.id);

                  try {
                    const res = await ApiHelper.post(
                      API.employerConfirm,
                      dataValue
                    );
                    setPdfViewer(false);
                    setLoader(false);
                  } catch (err) {}
                } else {
                  const formData = new FormData();
                  formData.append("formfieldid", item.id);
                  formData.append("filebuffencrypted", base64Data);
                  formData.append("filledBy", filledBy);
                  formData.append(
                    "template_id",
                    params.tempid !== undefined ? params.tempid : 0
                  );
                  if (form !== undefined) {
                    formData.append("formid", form.form_id);
                  }

                  try {
                    const res = await ApiHelper.post(
                      API.candidateSaveConvertedDocument,
                      formData
                    );
                    if (res) {
                      setPdfViewer(false);
                      setLoader(false);
                    } else {
                      // Handle the case when the response is falsy
                    }
                  } catch (err) {}
                }
              }
            };

            reader.readAsDataURL(value);
          } catch (error) {
            // Handle the error from saveAsBlob
            console.error("Error in saveAsBlobAsync:", error);
          }
        }
      } else {
        setPdfViewer(false);
      }
    }
  }

  async function saveAsBlobAsync(viewer) {
    return new Promise((resolve, reject) => {
      viewer.saveAsBlob().then(resolve).catch(reject);
    });
  }

  function closeModal() {
    setModalIsOpen(false);
  }

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      width: "45%",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      boxShadow: "1px 2px #888888",
    },
  };

  const customStyles_save = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      maxWidth: "500px",
      width: "100%",
      marginRight: "0%",
      transform: "translate(-50%, -50%)",
      boxShadow: "1px 2px #888888",
    },
  };

  const pdfViewerStyle = {
    backgroundColor: "#f8f8f8" /* Replace with your desired background color */,
  };

  const updatePageNavigation = () => {
    if (pdfViewerRef.current.currentPageNumber === 1) {
      toolbarRef.current.enableItems(
        document.getElementById("previous_page").parentElement,
        false
      );
      toolbarRef.current.enableItems(
        document.getElementById("next_page").parentElement,
        true
      );
    } else if (
      pdfViewerRef.current.currentPageNumber === pdfViewerRef.current.pageCount
    ) {
      toolbarRef.current.enableItems(
        document.getElementById("previous_page").parentElement,
        true
      );
      toolbarRef.current.enableItems(
        document.getElementById("next_page").parentElement,
        false
      );
    } else {
      toolbarRef.current.enableItems(
        document.getElementById("previous_page").parentElement,
        true
      );
      toolbarRef.current.enableItems(
        document.getElementById("next_page").parentElement,
        true
      );
    }
  };

  const documentLoaded = () => {
    var viewer = document.getElementById("container").ej2_instances[0];
    setCurrent_page_number(pdfViewerRef.current.currentPageNumber.toString());
    setTotalPageCount("of " + pdfViewerRef.current.pageCount);
    updatePageNavigation();
    var forms = viewer.formFieldCollections;
    if (data.title == "i-9.pdf" && data.employer_status != 1) {
      let validationError = null;
      for (let i = 0; i < forms.length; i++) {
        const field = forms[i];
        if (forms[i].name == "citizenship or immigration status") {
          viewer.formDesignerModule.updateFormField(forms[i], {
            isReadOnly: true,
          });
        }
        viewer.formDesignerModule.updateFormField(forms[i], {
          isReadOnly: true,
        });
      }
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "List A DocumentTitle25",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 168, Y: 577, Width: 184, Height: 24 },
        pageNumber: 1,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Textbox1",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 168, Y: 600, Width: 184, Height: 24 },
        pageNumber: 1,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "First Name2",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 168, Y: 623, Width: 184, Height: 24 },
        pageNumber: 1,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "First Name3",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 168, Y: 646, Width: 184, Height: 24 },
        pageNumber: 1,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "First Name4",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 168, Y: 671, Width: 184, Height: 24 },
        pageNumber: 1,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "First Name5",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 168, Y: 696, Width: 184, Height: 24 },
        pageNumber: 1,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "First Name6",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 168, Y: 719, Width: 184, Height: 24 },
        pageNumber: 1,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "First Name7",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 168, Y: 742, Width: 184, Height: 24 },
        pageNumber: 1,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "First Name8",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 168, Y: 765, Width: 184, Height: 24 },
        pageNumber: 1,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "First Name9",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 168, Y: 789, Width: 184, Height: 24 },
        pageNumber: 1,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "First Name0",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 168, Y: 812, Width: 184, Height: 24 },
        pageNumber: 1,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "First Name1",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 168, Y: 837, Width: 184, Height: 24 },
        pageNumber: 1,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "First Name11iv",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 367, Y: 577, Width: 191, Height: 24 },
        pageNumber: 1,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "First Name12",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 367, Y: 600, Width: 191, Height: 24 },
        pageNumber: 1,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "First Name13",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 367, Y: 623, Width: 191, Height: 24 },
        pageNumber: 1,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "First Name14",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 367, Y: 646, Width: 191, Height: 24 },
        pageNumber: 1,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "First Name15",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 562, Y: 577, Width: 205, Height: 24 },
        pageNumber: 1,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "First Name16",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 562, Y: 600, Width: 205, Height: 24 },
        pageNumber: 1,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "First Name17",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 562, Y: 623, Width: 205, Height: 24 },
        pageNumber: 1,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "First Name18",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 562, Y: 646, Width: 205, Height: 24 },
        pageNumber: 1,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "First Name19",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        isMultiline: true,
        bounds: { X: 355, Y: 690, Width: 409, Height: 156 },
        pageNumber: 1,
      });
      viewer.formDesignerModule.addFormField("CheckBox", {
        name: "ch1",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 355, Y: 846, Width: 13, Height: 13 },
        pageNumber: 1,
      });

      viewer.formDesignerModule.addFormField("Textbox", {
        name: "First Day of Employment",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        borderColor: "#fff",
        isRequired: true,
        bounds: { X: 610, Y: 887, Width: 158, Height: 22 },
        pageNumber: 1,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Last Name, First Name and Title of Employer or Authorized Representative",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        isRequired: true,
        bounds: { X: 49, Y: 923, Width: 310, Height: 24 },
        pageNumber: 1,
      });
      viewer.formDesignerModule.addFormField("SignatureField", {
        name: "Signature of Employer or Authorized Representative",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        isRequired: true,
        bounds: { X: 390, Y: 923, Width: 240, Height: 24 },
        pageNumber: 1,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Today's Date (mm/dd/yyyy)",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        isRequired: true,
        borderColor: "#fff",
        bounds: { X: 650, Y: 923, Width: 118, Height: 24 },
        pageNumber: 1,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Employer's Business or Organization Name",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        isRequired: true,
        bounds: { X: 49, Y: 965, Width: 240, Height: 20 },
        pageNumber: 1,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Employer's Business or Organization Address, City or Town, State, ZIP Code",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        isRequired: true,
        bounds: { X: 320, Y: 965, Width: 440, Height: 20 },
        pageNumber: 1,
      });

      viewer.formDesignerModule.addFormField("Textbox", {
        name: "First Name20-",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 49, Y: 150, Width: 290, Height: 24 },
        pageNumber: 3,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Middle Name21we",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 348, Y: 150, Width: 235, Height: 24 },
        pageNumber: 3,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "First Name11wwbq",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 585, Y: 150, Width: 185, Height: 24 },
        pageNumber: 3,
      });

      viewer.formDesignerModule.addFormField("SignatureField", {
        name: "name1",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 49.28, Y: 310, Width: 500, Height: 26.182666666666666 },
        pageNumber: 3,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "name2",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 557, Y: 310, Width: 200, Height: 26.182666666666666 },
        pageNumber: 3,
      });

      viewer.formDesignerModule.addFormField("Textbox", {
        name: "name3",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 49.28, Y: 350, Width: 300, Height: 26.182666666666666 },
        pageNumber: 3,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Last Name Family Name from Section 129",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 365, Y: 350, Width: 292, Height: 26.182666666666666 },
        pageNumber: 3,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator City or Town 030",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 660, Y: 350, Width: 110, Height: 26.182666666666666 },
        pageNumber: 3,
      });

      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Last Name Family Name from Section 134",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 49.28, Y: 390, Width: 340, Height: 26.182666666666666 },
        pageNumber: 3,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator City or Town 035",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 391, Y: 390, Width: 208, Height: 26.182666666666666 },
        pageNumber: 3,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator City or Town 036",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 600, Y: 390, Width: 56, Height: 26.182666666666666 },
        pageNumber: 3,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator First Name (Given Name) 337",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 658, Y: 390, Width: 109, Height: 26 },
        pageNumber: 3,
      });

      viewer.formDesignerModule.addFormField("SignatureField", {
        name: "Last Name Family Name from Section 138",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 49.28, Y: 475, Width: 500, Height: 26 },
        pageNumber: 3,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator City or Town 039",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 557, Y: 475, Width: 210, Height: 26 },
        pageNumber: 3,
      });

      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Last Name Family Name from Section 131",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 49.28, Y: 520, Width: 308, Height: 26.182666666666666 },
        pageNumber: 3,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator First Name (Given Name) 332",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 362, Y: 520, Width: 292, Height: 26.182666666666666 },
        pageNumber: 3,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator First Name (Given Name) 333",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 656, Y: 520, Width: 110, Height: 25.182666666666666 },
        pageNumber: 3,
      });

      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Last Name Family Name from Section 143",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 49.28, Y: 560, Width: 340, Height: 26.182666666666666 },
        pageNumber: 3,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator City or Town 044",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 391, Y: 560, Width: 208, Height: 26.182666666666666 },
        pageNumber: 3,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator City or Town 045",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 600, Y: 560, Width: 56, Height: 26.182666666666666 },
        pageNumber: 3,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator First Name (Given Name) 346",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 658, Y: 560, Width: 109, Height: 26 },
        pageNumber: 3,
      });

      viewer.formDesignerModule.addFormField("SignatureField", {
        name: "Last Name Family Name from Section 147",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 49.28, Y: 644, Width: 500, Height: 30 },
        pageNumber: 3,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator City or Town 048",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 557, Y: 644, Width: 210, Height: 30 },
        pageNumber: 3,
      });

      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Last Name Family Name from Section 149",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 49.28, Y: 687, Width: 308, Height: 26.182666666666666 },
        pageNumber: 3,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator First Name (Given Name) 350",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 362, Y: 687, Width: 292, Height: 26.182666666666666 },
        pageNumber: 3,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator First Name (Given Name) 351",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 656, Y: 687, Width: 110, Height: 25.182666666666666 },
        pageNumber: 3,
      });

      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Last Name Family Name from Section 152",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 49.28, Y: 728, Width: 340, Height: 26.182666666666666 },
        pageNumber: 3,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator City or Town 053",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 391, Y: 728, Width: 208, Height: 26.182666666666666 },
        pageNumber: 3,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator City or Town 054",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 600, Y: 728, Width: 56, Height: 26.182666666666666 },
        pageNumber: 3,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator First Name (Given Name) 355",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 658, Y: 728, Width: 109, Height: 26 },
        pageNumber: 3,
      });

      viewer.formDesignerModule.addFormField("SignatureField", {
        name: "Last Name Family Name from Section 156",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 49.28, Y: 810, Width: 500, Height: 30 },
        pageNumber: 3,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "ch8 date",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 557, Y: 810, Width: 210, Height: 30 },
        pageNumber: 3,
      });

      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Last Name Family Name from Section 158",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 49.28, Y: 856, Width: 308, Height: 26.182666666666666 },
        pageNumber: 3,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator First Name (Given Name) 359",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 362, Y: 856, Width: 292, Height: 26.182666666666666 },
        pageNumber: 3,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator First Name (Given Name) 360",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 656, Y: 856, Width: 110, Height: 25.182666666666666 },
        pageNumber: 3,
      });

      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Last Name Family Name from Section 161",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 49.28, Y: 898, Width: 340, Height: 24 },
        pageNumber: 3,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator City or Town 062",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 391, Y: 898, Width: 208, Height: 24 },
        pageNumber: 3,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator City or Town 063",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 600, Y: 898, Width: 56, Height: 24 },
        pageNumber: 3,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator First Name (Given Name) 364",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 658, Y: 898, Width: 109, Height: 24 },
        pageNumber: 3,
      });

      viewer.formDesignerModule.addFormField("Textbox", {
        name: "First Name201",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 49, Y: 152, Width: 290, Height: 24 },
        pageNumber: 4,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Middle Name21",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 348, Y: 152, Width: 235, Height: 24 },
        pageNumber: 4,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "First Name11e",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 585, Y: 152, Width: 185, Height: 24 },
        pageNumber: 4,
      });

      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Last Name Family Name from Section 168",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 49.28, Y: 286, Width: 132, Height: 26.182666666666666 },
        pageNumber: 4,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator First Name (Given Name) 369",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: {
          X: 184,
          Y: 286,
          Width: 265.44002666666665,
          Height: 26.182666666666666,
        },
        pageNumber: 4,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator City or Town 070",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 450, Y: 286, Width: 238, Height: 26.182666666666666 },
        pageNumber: 4,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator First Name (Given Name) 371",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 692, Y: 286, Width: 70, Height: 26 },
        pageNumber: 4,
      });

      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Last Name Family Name from Section 165",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 49.28, Y: 358, Width: 273.44002666666665, Height: 22 },
        pageNumber: 4,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator First Name (Given Name) 366",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: {
          X: 320.1093333333333,
          Y: 358,
          Width: 260.44002666666665,
          Height: 22,
        },
        pageNumber: 4,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator City or Town 067",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 592, Y: 358, Width: 175, Height: 22 },
        pageNumber: 4,
      });

      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator First Name (Given Name) 372",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: {
          X: 49.28,
          Y: 428,
          Width: 265.44002666666665,
          Height: 26.182666666666666,
        },
        pageNumber: 4,
      });
      viewer.formDesignerModule.addFormField("SignatureField", {
        name: "Preparer or Translator First Name (Given Name) 373wqfv",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: {
          X: 322,
          Y: 428,
          Width: 280.44002666666665,
          Height: 26.182666666666666,
        },
        pageNumber: 4,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator City or Town 0745",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 630, Y: 428, Width: 130, Height: 26.182666666666666 },
        pageNumber: 4,
      });

      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator City or Town 0743",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 49.28, Y: 475, Width: 550, Height: 29.182666666666666 },
        pageNumber: 4,
      });
      viewer.formDesignerModule.addFormField("CheckBox", {
        name: "ch3",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 608, Y: 475, Width: 13, Height: 13 },
        pageNumber: 4,
      });

      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Last Name Family Name from Section 168i",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 49.28, Y: 535, Width: 132, Height: 26.182666666666666 },
        pageNumber: 4,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator First Name (Given Name) 369r",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: {
          X: 184,
          Y: 535,
          Width: 265.44002666666665,
          Height: 26.182666666666666,
        },
        pageNumber: 4,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator City or Town 070io",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 450, Y: 535, Width: 238, Height: 26.182666666666666 },
        pageNumber: 4,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator First Name (Given Name) 371uvn",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 692, Y: 535, Width: 70, Height: 26 },
        pageNumber: 4,
      });

      viewer.formDesignerModule.addFormField("Textbox", {
        name: "First Name202",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 49, Y: 605, Width: 272, Height: 24 },
        pageNumber: 4,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Middle Name21u",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 327, Y: 605, Width: 255, Height: 24 },
        pageNumber: 4,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "First Name11tr",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 592, Y: 605, Width: 176, Height: 24 },
        pageNumber: 4,
      });

      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator First Name (Given Name) 372qw",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: {
          X: 49.28,
          Y: 676,
          Width: 265.44002666666665,
          Height: 26.182666666666666,
        },
        pageNumber: 4,
      });
      viewer.formDesignerModule.addFormField("SignatureField", {
        name: "Preparer or Translator First Name (Given Name) 373-o",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: {
          X: 322,
          Y: 676,
          Width: 285.44002666666665,
          Height: 26.182666666666666,
        },
        pageNumber: 4,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator City or Town 074",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 630, Y: 676, Width: 130, Height: 26.182666666666666 },
        pageNumber: 4,
      });

      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator City or Town 074hq",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 49.28, Y: 720, Width: 550, Height: 29.182666666666666 },
        pageNumber: 4,
      });
      viewer.formDesignerModule.addFormField("CheckBox", {
        name: "ch9",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 608, Y: 720, Width: 13, Height: 13 },
        pageNumber: 4,
      });

      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Last Name Family Name from Section 168p",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 49.28, Y: 783, Width: 132, Height: 26.182666666666666 },
        pageNumber: 4,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator First Name (Given Name) 369i",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: {
          X: 184,
          Y: 783,
          Width: 265.44002666666665,
          Height: 26.182666666666666,
        },
        pageNumber: 4,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator City or Town 070t",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 450, Y: 783, Width: 238, Height: 26.182666666666666 },
        pageNumber: 4,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator First Name (Given Name) 371qd",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 692, Y: 783, Width: 70, Height: 26 },
        pageNumber: 4,
      });

      viewer.formDesignerModule.addFormField("Textbox", {
        name: "First Name203",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 49, Y: 857, Width: 272, Height: 20 },
        pageNumber: 4,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Middle Name21iv",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 327, Y: 857, Width: 255, Height: 20 },
        pageNumber: 4,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "First Name11pl",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 592, Y: 857, Width: 176, Height: 20 },
        pageNumber: 4,
      });

      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator First Name (Given Name) 372fd",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: {
          X: 49.28,
          Y: 924,
          Width: 265.44002666666665,
          Height: 26.182666666666666,
        },
        pageNumber: 4,
      });
      viewer.formDesignerModule.addFormField("SignatureField", {
        name: "Preparer or Translator First Name (Given Name) 373i-of",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: {
          X: 322,
          Y: 924,
          Width: 285.44002666666665,
          Height: 26.182666666666666,
        },
        pageNumber: 4,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator City or Town 074opg",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 630, Y: 924, Width: 130, Height: 26.182666666666666 },
        pageNumber: 4,
      });

      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Preparer or Translator City or Town 073",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 49.28, Y: 970, Width: 550, Height: 29.182666666666666 },
        pageNumber: 4,
      });
      viewer.formDesignerModule.addFormField("CheckBox", {
        name: "ch6",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        bounds: { X: 608, Y: 970, Width: 13, Height: 13 },
        pageNumber: 4,
      });

      // viewer.formDesignerModule.addFormField("checkbox", { name: "Preparer or Translator City or Town 074",backgroundColor:"#ffffff",color: "black",fontFamily: "Helvetica", bounds: { X: 49.28, Y: 970, Width: 550, Height: 29.182666666666666 },pageNumber: 4});
      setDocumentLoadedCalled(true);
    } else if (data.title == "w4.pdf" && data.employer_status != 1) {
      for (let i = 0; i < forms.length; i++) {
        const field = forms[i];
        if (forms[i].name == "filingStatus") {
          viewer.formDesignerModule.updateFormField(forms[i], {
            isReadOnly: true,
          });
        }
        viewer.formDesignerModule.updateFormField(forms[i], {
          isReadOnly: true,
        });
      }
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Employer’s name",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        isRequired: true,
        bounds: { X: 124, Y: 880, Width: 150, Height: 24 },
        pageNumber: 1,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Employer’s address",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        isRequired: true,
        bounds: { X: 124, Y: 903, Width: 394, Height: 24 },
        pageNumber: 1,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "First date of employment",
        backgroundColor: "#ffffff",
        color: "black",
        fontFamily: "Helvetica",
        isRequired: true,
        bounds: { X: 520, Y: 903, Width: 100, Height: 24 },
        pageNumber: 1,
      });
      viewer.formDesignerModule.addFormField("Textbox", {
        name: "Employer identification number (EIN)",
        backgroundColor: "#ffffff",
        bordercolor: "black",
        color: "black",
        fontFamily: "Helvetica",
        isRequired: true,
        bounds: { X: 625, Y: 903, Width: 150, Height: 24 },
        pageNumber: 1,
      });
    } else if (data.title == "w4.pdf" && data.employer_status == 1) {
      for (let i = 0; i < forms.length; i++) {
        const field = forms[i];
        if (
          forms[i].name == "Employer’s name" ||
          forms[i].name == "Employer’s address" ||
          forms[i].name == "First date of employment" ||
          forms[i].name == "Employer identification number (EIN)"
        ) {
          viewer.formDesignerModule.updateFormField(forms[i], {
            isReadOnly: false,
          });
        } else if (forms[i].name == "filingStatus") {
          viewer.formDesignerModule.updateFormField(forms[i], {
            isReadOnly: true,
          });
        }
      }
    } else if (data.title == "i-9.pdf" && data.employer_status == 1) {
      for (let i = 0; i < forms.length; i++) {
        if (forms[i].type !== "SignatureField") {
          if (forms[i].name == "Last Name") {
            viewer.formDesignerModule.updateFormField(forms[i], {
              isReadOnly: true,
            });
          } else if (forms[i].name == "First Name (Given Name)") {
            viewer.formDesignerModule.updateFormField(forms[i], {
              isReadOnly: true,
            });
          } else if (forms[i].name == "Employee Middle Initial (if any)") {
            viewer.formDesignerModule.updateFormField(forms[i], {
              isReadOnly: true,
            });
          } else if (
            forms[i].name == "Employee Other Last Names Used (if any)"
          ) {
            viewer.formDesignerModule.updateFormField(forms[i], {
              isReadOnly: true,
            });
          } else if (forms[i].name == "Address Street Number and Name") {
            viewer.formDesignerModule.updateFormField(forms[i], {
              isReadOnly: true,
            });
          } else if (forms[i].name == "Apt Number (if any)") {
            viewer.formDesignerModule.updateFormField(forms[i], {
              isReadOnly: true,
            });
          } else if (forms[i].name == "City or Town") {
            viewer.formDesignerModule.updateFormField(forms[i], {
              isReadOnly: true,
            });
          } else if (forms[i].name == "State") {
            viewer.formDesignerModule.updateFormField(forms[i], {
              isReadOnly: true,
            });
          } else if (forms[i].name == "ZIP Code") {
            viewer.formDesignerModule.updateFormField(forms[i], {
              isReadOnly: true,
            });
          } else if (forms[i].name == "Date of Birth (mm/dd/yyyy)") {
            viewer.formDesignerModule.updateFormField(forms[i], {
              isReadOnly: true,
            });
          } else if (forms[i].name == "US Social Security Number") {
            viewer.formDesignerModule.updateFormField(forms[i], {
              isReadOnly: true,
            });
          } else if (forms[i].name == "Employees E-mail Address") {
            viewer.formDesignerModule.updateFormField(forms[i], {
              isReadOnly: true,
            });
          } else if (forms[i].name == "Telephone Number") {
            viewer.formDesignerModule.updateFormField(forms[i], {
              isReadOnly: true,
            });
          } else if (forms[i].name == "citizenship or immigration status") {
            viewer.formDesignerModule.updateFormField(forms[i], {
              isReadOnly: true,
            });
          } else if (
            forms[i].name ==
            "3 A lawful permanent resident Enter USCIS or ANumber"
          ) {
            viewer.formDesignerModule.updateFormField(forms[i], {
              isReadOnly: true,
            });
          } else if (forms[i].name == "Exp Date mmddyyyy") {
            viewer.formDesignerModule.updateFormField(forms[i], {
              isReadOnly: true,
            });
          } else if (forms[i].name == "USCIS ANumber") {
            viewer.formDesignerModule.updateFormField(forms[i], {
              isReadOnly: true,
            });
          } else if (forms[i].name == "Form I94 Admission Number") {
            viewer.formDesignerModule.updateFormField(forms[i], {
              isReadOnly: true,
            });
          } else if (
            forms[i].name ==
            "Foreign Passport Number and Country of IssuanceRow1"
          ) {
            viewer.formDesignerModule.updateFormField(forms[i], {
              isReadOnly: true,
            });
          } else if (forms[i].name == "Today's Date (mm/dd/yyyy)") {
            viewer.formDesignerModule.updateFormField(forms[i], {
              isReadOnly: true,
            });
          } else {
            viewer.formDesignerModule.updateFormField(forms[i], {
              isReadOnly: false,
            });
          }
        }
      }
    }
  };

  function inputTemplate() {
    return (
      <div>
        <input
          type="text"
          className="e-input-group e-pv-current-page-number"
          id="currentPage"
          value={current_page_number}
        />
      </div>
    );
  }

  function template() {
    return (
      <div>
        <span className="e-pv-total-page-number" id="totalPage">
          {totalPageCount}
        </span>
      </div>
    );
  }

  return (
    <div>
      <div className="row">
        <div className="col-lg-12 ">
          <div className="pdf-doc viewerPage">
            <Modal
              isOpen={modalIsOpen}
              // onRequestClose={closeModal}
              style={customStyles_save}
              contentLabel="Example Modal"
            >
              <div className="modal-width savePopus">
                <div class="modal-header">
                  <h4 class="modal-title d-flex align-items-center">
                    <img
                      src={Alert}
                      alt="copy"
                      className="create-icon mb-0 me-2"
                    />{" "}
                    Message
                  </h4>
                  <button onClick={closeModal} className="modal-close">
                    {" "}
                    <img
                      src={closex}
                      alt="copy"
                      className="create-icon mb-0 me-2"
                    />
                  </button>
                </div>

                <div className="modal-delect-text txtFonts">{errorValue}</div>
                <div class="modal-footer footer-marg-pdf">
                  <button
                    type="button"
                    class="yes-btn rounded p-2"
                    onClick={closeModal}
                  >
                    Close
                  </button>
                </div>
              </div>
            </Modal>

            <div className="control-section">
              {/* Render the PDF Viewer */}
              {currentPath == "review" ? (
                <>
                  <div className="center-div">
                    <div className="control-section doct-divz">
                      <div className="e-pdf-toolbar custIcons bottom-space">
                        <ToolbarComponent
                          ref={toolbarRef}
                          clicked={clickHandler.bind(this)}
                        >
                          <ItemsDirective>
                            <ItemDirective
                              prefixIcon="e-pv-previous-page-navigation-icon"
                              id="previous_page"
                              tooltipText="Previous Page"
                            ></ItemDirective>
                            <ItemDirective
                              prefixIcon="e-pv-next-page-navigation-icon"
                              id="next_page"
                              tooltipText="Next Page"
                            ></ItemDirective>
                            <ItemDirective
                              template={inputTemplate}
                              tooltipText="Page Number"
                              type="Input"
                            ></ItemDirective>
                            <ItemDirective
                              template={template}
                              tooltipText="Page Number"
                              id="page-no-border"
                            ></ItemDirective>
                            <ItemDirective
                              prefixIcon="e-pv-zoom-out-sample"
                              id="zoom_out"
                              tooltipText="Zoom out"
                            ></ItemDirective>
                            <ItemDirective
                              prefixIcon="e-pv-zoom-in-icon"
                              id="zoom_in"
                              tooltipText="Zoom in"
                            ></ItemDirective>
                            <ItemDirective
                              text="Insert text"
                              tooltipText="form_designer"
                              id="form_designer"
                            ></ItemDirective>
                            {currentPath == "review" ? (
                              <ItemDirective
                                text="Cancel"
                                id="cancel"
                                align="Right"
                                tooltipText="Cancel"
                              ></ItemDirective>
                            ) : (
                              ""
                            )}
                            <ItemDirective
                              text={buttonText}
                              tooltipText={buttonText}
                              id="download"
                              align="Right"
                            ></ItemDirective>
                          </ItemsDirective>
                        </ToolbarComponent>
                        <PdfViewerComponent
                          className="pdfHeight_new"
                          ref={pdfViewerRef}
                          id="container"
                          created={created}
                          showNotificationDialog={false}
                          enableAnnotation={true}
                          enableToolbar={false}
                          documentLoad={documentLoaded}
                          toolbarSettings={{
                            showTooltip: true,
                            annotationToolbarItems: [
                              "HighlightTool",
                              "UnderlineTool",
                              "StrikethroughTool",
                              "ColorEditTool",
                              "OpacityEditTool",

                              "ThicknessEditTool",
                              "FreeTextAnnotationTool",
                            ],
                            toolbarItems: [
                              "PageNavigationTool",
                              "MagnificationTool",
                              "AnnotationEditTool",
                              "SearchOption",
                            ],
                          }}
                          // documentPath="https://cdn.syncfusion.com/content/pdf/pdf-succinctly.pdf"
                          serviceUrl="https://ej2services.syncfusion.com/production/web-services/api/pdfviewer"
                          // serviceUrl="http://208.109.14.7/pdfviewer"
                          style={pdfViewerStyle}
                        >
                          <Inject
                            services={[
                              Toolbar,
                              Magnification,
                              Navigation,
                              Annotation,
                              LinkAnnotation,
                              BookmarkView,
                              ThumbnailView,
                              Print,
                              TextSelection,
                              TextSearch,
                              FormFields,
                              FormDesigner,
                            ]}
                          />
                        </PdfViewerComponent>
                        {/* <PdfViewerComponent
                          id="container"
                          className="pdfHeight_new"
                          documentPath="FormDesigner.pdf"
                          created={created}
                          serviceUrl="http://208.109.14.7/pdfviewer"
                          // serviceUrl="https://ej2services.syncfusion.com/production/web-services/api/pdfviewer"
                          showNotificationDialog={false}
                          style={pdfViewerStyle}
                          documentLoad={documentLoaded}
                          enableAnnotation={true}
                          enableToolbar={false}
                          ref={pdfViewerRef} // Use ref to get a reference to the PDF viewer component
                          toolbarSettings={{
                            showTooltip: true,
                            annotationToolbarItems: [
                              "HighlightTool",
                              "UnderlineTool",
                              "StrikethroughTool",
                              "ColorEditTool",
                              "OpacityEditTool",

                              "ThicknessEditTool",
                              "FreeTextAnnotationTool",
                            ],
                            toolbarItems: [
                              "PageNavigationTool",
                              "MagnificationTool",
                              "AnnotationEditTool",
                              "SearchOption",
                            ],
                          }}
                        >
                          <Inject
                            services={[
                              Toolbar,
                              Magnification,
                              Navigation,
                              LinkAnnotation,
                              BookmarkView,
                              ThumbnailView,
                              Print,
                              TextSelection,
                              TextSearch,
                              Annotation,
                              FormFields,
                              FormDesigner,
                            ]}
                          />
                        </PdfViewerComponent> */}
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <div>
                  <div className="e-pdf-toolbar">
                    <ToolbarComponent
                      ref={(scope) => {
                        toolbar = scope;
                      }}
                      clicked={clickHandler.bind(this)}
                    >
                      <ItemsDirective>
                        <ItemDirective
                          text={buttonText}
                          tooltipText={buttonText}
                          id="download"
                          align="Right"
                        ></ItemDirective>
                      </ItemsDirective>
                    </ToolbarComponent>
                  </div>
                  <PdfViewerComponent
                    id="container"
                    className="pdfHeight_new"
                    documentPath="FormDesigner.pdf"
                    // serviceUrl="http://208.109.14.7/pdfviewer"
                    created={created}
                    serviceUrl="https://ej2services.syncfusion.com/production/web-services/api/pdfviewer"
                    showNotificationDialog={false}
                    enableToolbar={true}
                    readOnly={true}
                    ref={pdfViewerRef} // Use ref to get a reference to the PDF viewer component
                    toolbarSettings={{
                      showTooltip: true,
                      toolbarItems: ["MagnificationTool"],
                    }}
                  >
                    <Inject
                      services={[
                        Toolbar,
                        Magnification,
                        Navigation,
                        LinkAnnotation,
                        BookmarkView,
                        ThumbnailView,
                        Print,
                        TextSelection,
                        TextSearch,
                        Annotation,
                        FormFields,
                        FormDesigner,
                      ]}
                    />
                  </PdfViewerComponent>
                </div>
              )}
            </div>
            {loader && <Spinner />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentUpload;
